export const data = [{
    name: "House 1",
    image: "https://images.unsplash.com/photo-1600585152220-90363fe7e115?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=870&q=80",
    price: 450,
    address: "204-abc nagar,xyz-road",
    city: "MUMBAI",
    info: {
        bed: 5,
        bathrooms: 2,
        area: "33x4",
        date: [1, 31]
    },
    type: "All house"
}, {
    name: "House 2",
    image: "https://images.unsplash.com/photo-1628624747186-a941c476b7ef?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=870&q=80",
    price: 899,
    city: "CHENNAI",
    address: "204-bbc nagar,ayz-road",
    info: {
        bed: 3,
        bathrooms: 1,
        area: "36x2",
        date: [1, 31]
    },
    type: "All pg"
}, {
    name: "House 3",
    image: "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxzZWFyY2h8M3x8aG9tZXN8ZW58MHx8MHx8&auto=format&fit=crop&w=500&q=60",
    price: 1450,
    city: "HYDERABAD",
    address: "204-cbc nagar,byz-road",
    info: {
        bed: 2,
        bathrooms: 6,
        area: "76x2",
        date: [1, 31]
    },
    type: "All farm-house"
}, {
    name: "House 4",
    image: "https://images.unsplash.com/photo-1569172772440-9f5fa203cd3a?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxjb2xsZWN0aW9uLXBhZ2V8MXwyMzAzMTUxfHxlbnwwfHx8fA%3D%3D&auto=format&fit=crop&w=500&q=60",
    price: 1899,
    city: "KOLKATA",
    address: "204-dbc nagar,cyz-road",
    info: {
        bed: 4,
        bathrooms: 4,
        area: "100x20",
        date: [1, 31]
    },
    type: "All villa"
}, {
    name: "House 5",
    image: "https://images.unsplash.com/photo-1489370321024-e0410ad08da4?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=870&q=80",
    price: 2400,
    city: "UDAIPUR",
    address: "204-ebc nagar,dyz-road",
    info: {
        bed: 2,
        bathrooms: 1,
        area: "76x2",
        date: [1, 31]
    },
    type: "All hotel"
}, {
    name: "House 6",
    image: "https://images.unsplash.com/photo-1533682850979-2f18860789d6?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=870&q=80",
    price: 2800,
    city: "PUNE",
    address: "204-fbc nagar,eyz-road",
    info: {
        bed: 1,
        bathrooms: 1,
        area: "76x2",
        date: [1, 31]
    },
    type: "All oyo"
}, {
    name: "House 7",
    image: "https://images.unsplash.com/photo-1566415057360-6e897a5b44d5?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxjb2xsZWN0aW9uLXBhZ2V8OHwyMzAzMTUxfHxlbnwwfHx8fA%3D%3D&auto=format&fit=crop&w=500&q=60",
    price: 450,
    address: "204-gbc nagar,fyz-road",
    city: "BANGLORE",
    info: {
        bed: 5,
        bathrooms: 2,
        area: "33x4",
        date: [1, 31]
    },
    type: "All house"
}, {
    name: "House 8",
    image: "https://images.unsplash.com/photo-1507204135820-e462b349179f?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxjb2xsZWN0aW9uLXBhZ2V8N3wyMzAzMTUxfHxlbnwwfHx8fA%3D%3D&auto=format&fit=crop&w=500&q=60",
    price: 899,
    city: "AHEMDABAD",
    address: "204-hbc nagar,gyz-road",
    info: {
        bed: 3,
        bathrooms: 1,
        area: "36x2",
        date: [1, 31]
    },
    type: "All pg"
}, {
    name: "House 9",
    image: "https://images.unsplash.com/photo-1560105152-eb9667affb6a?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxjb2xsZWN0aW9uLXBhZ2V8OXwyMzAzMTUxfHxlbnwwfHx8fA%3D%3D&auto=format&fit=crop&w=500&q=60",
    price: 1450,
    city: "SURAT",
    address: "204-ibc nagar,hyz-road",
    info: {
        bed: 2,
        bathrooms: 6,
        area: "76x2",
        date: [1, 31]
    },
    type: "All farm-house"
}, {
    name: "House 10",
    image: "https://images.unsplash.com/photo-1534986145647-1c8483859a9a?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxjb2xsZWN0aW9uLXBhZ2V8MTF8MjMwMzE1MXx8ZW58MHx8fHw%3D&auto=format&fit=crop&w=500&q=60",
    price: 1899,
    city: "VISHAKAPATNAM",
    address: "204-jbc nagar,iyz-road",
    info: {
        bed: 4,
        bathrooms: 4,
        area: "100x20",
        date: [1, 31]
    },
    type: "All villa"
}, {
    name: "House 11",
    image: "https://images.unsplash.com/photo-1537269700156-2fb9dfb6fdd0?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxjb2xsZWN0aW9uLXBhZ2V8MTJ8MjMwMzE1MXx8ZW58MHx8fHw%3D&auto=format&fit=crop&w=500&q=60",
    price: 2400,
    city: "New Delhi",
    address: "204-kbc nagar,jyz-road",
    info: {
        bed: 2,
        bathrooms: 1,
        area: "76x2",
        date: [1, 31]
    },
    type: "All hotel"
}, {
    name: "House 12",
    image: "https://images.unsplash.com/photo-1532695658265-5e9be3ea2b7c?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxjb2xsZWN0aW9uLXBhZ2V8MTN8MjMwMzE1MXx8ZW58MHx8fHw%3D&auto=format&fit=crop&w=500&q=60",
    price: 2800,
    city: "LUCKNOW",
    address: "204-lbc nagar,kyz-road",
    info: {
        bed: 1,
        bathrooms: 1,
        area: "76x2",
        date: [1, 31]
    },
    type: "All oyo"
}, {
    name: "House 13",
    image: "https://images.unsplash.com/photo-1547438741-d81b3a27a270?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxjb2xsZWN0aW9uLXBhZ2V8MTV8MjMwMzE1MXx8ZW58MHx8fHw%3D&auto=format&fit=crop&w=500&q=60",
    price: 450,
    address: "204-mbc nagar,lyz-road",
    city: "AGRA",
    info: {
        bed: 5,
        bathrooms: 2,
        area: "33x4",
        date: [1, 31]
    },
    type: "All house"
}, {
    name: "House 14",
    image: "https://images.unsplash.com/photo-1547440077-88b879329eb4?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxjb2xsZWN0aW9uLXBhZ2V8MTZ8MjMwMzE1MXx8ZW58MHx8fHw%3D&auto=format&fit=crop&w=500&q=60",
    price: 899,
    city: "INDORE",
    address: "204-nbc nagar,myz-road",
    info: {
        bed: 3,
        bathrooms: 1,
        area: "36x2",
        date: [1, 31]
    },
    type: "All pg"
}, {
    name: "House 15",
    image: "https://images.unsplash.com/photo-1538973947079-ff96f5daf40e?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxjb2xsZWN0aW9uLXBhZ2V8MTd8MjMwMzE1MXx8ZW58MHx8fHw%3D&auto=format&fit=crop&w=500&q=60",
    price: 1450,
    city: "JAIPUR",
    address: "204-obc nagar,nyz-road",
    info: {
        bed: 2,
        bathrooms: 6,
        area: "76x2",
        date: [1, 31]
    },
    type: "All farm-house"
}, {
    name: "House 16",
    image: "https://images.unsplash.com/photo-1549070151-4fe9d7bbb969?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxjb2xsZWN0aW9uLXBhZ2V8MTh8MjMwMzE1MXx8ZW58MHx8fHw%3D&auto=format&fit=crop&w=500&q=60",
    price: 1899,
    city: "PATNA",
    address: "204-pbc nagar,oyz-road",
    info: {
        bed: 4,
        bathrooms: 4,
        area: "100x20",
        date: [1, 31]
    },
    type: "All villa"
}, {
    name: "House 17",
    image: "https://images.unsplash.com/photo-1544642182-a3ae27c6b1a4?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxjb2xsZWN0aW9uLXBhZ2V8MjF8MjMwMzE1MXx8ZW58MHx8fHw%3D&auto=format&fit=crop&w=500&q=60",
    price: 2400,
    city: "NAGPUR",
    address: "204-qbc nagar,pyz-road",
    info: {
        bed: 2,
        bathrooms: 1,
        area: "76x2",
        date: [1, 31]
    },
    type: "All hotel"
}, {
    name: "House 18",
    image: "https://images.unsplash.com/photo-1544587473-3c6fef61ed3c?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxjb2xsZWN0aW9uLXBhZ2V8MTl8MjMwMzE1MXx8ZW58MHx8fHw%3D&auto=format&fit=crop&w=500&q=60",
    price: 2800,
    city: "CHANDIGARH",
    address: "204-rbc nagar,qyz-road",
    info: {
        bed: 1,
        bathrooms: 1,
        area: "76x2",
        date: [1, 31]
    },
    type: "All oyo"
}, {
    name: "House 19",
    image: "https://images.unsplash.com/photo-1543869154-358ab830e541?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxjb2xsZWN0aW9uLXBhZ2V8MjB8MjMwMzE1MXx8ZW58MHx8fHw%3D&auto=format&fit=crop&w=500&q=60",
    price: 450,
    address: "204-sbc nagar,ryz-road",
    city: "BHOPAL",
    info: {
        bed: 5,
        bathrooms: 2,
        area: "33x4",
        date: [1, 31]
    },
    type: "All house"
}, {
    name: "House 20",
    image: "https://images.unsplash.com/photo-1463944073897-106bf17bd49b?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxjb2xsZWN0aW9uLXBhZ2V8MjJ8MjMwMzE1MXx8ZW58MHx8fHw%3D&auto=format&fit=crop&w=500&q=60",
    price: 899,
    city: "NOIDA",
    address: "204-tbc nagar,syz-road",
    info: {
        bed: 3,
        bathrooms: 1,
        area: "36x2",
        date: [1, 31]
    },
    type: "All pg"
}, {
    name: "House 21",
    image: "https://images.unsplash.com/photo-1530975271199-c373eb941d42?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxjb2xsZWN0aW9uLXBhZ2V8MjN8MjMwMzE1MXx8ZW58MHx8fHw%3D&auto=format&fit=crop&w=500&q=60",
    price: 1450,
    city: "KANPUR",
    address: "204-ubc nagar,tyz-road",
    info: {
        bed: 2,
        bathrooms: 6,
        area: "76x2",
        date: [1, 31]
    },
    type: "All farm-house"
}, {
    name: "House 22",
    image: "https://images.unsplash.com/photo-1530811592567-2c56ea1ca8f0?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxjb2xsZWN0aW9uLXBhZ2V8MjV8MjMwMzE1MXx8ZW58MHx8fHw%3D&auto=format&fit=crop&w=500&q=60",
    price: 1899,
    city: "GHAZIABAD",
    address: "204-vbc nagar,uyz-road",
    info: {
        bed: 4,
        bathrooms: 4,
        area: "100x20",
        date: [1, 31]
    },
    type: "All villa"
}, {
    name: "House 23",
    image: "https://images.unsplash.com/photo-1530811363243-8bab4d12a4bb?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxjb2xsZWN0aW9uLXBhZ2V8MjR8MjMwMzE1MXx8ZW58MHx8fHw%3D&auto=format&fit=crop&w=500&q=60",
    price: 2400,
    city: "VARANASI",
    address: "204-wbc nagar,vyz-road",
    info: {
        bed: 2,
        bathrooms: 1,
        area: "76x2",
        date: [1, 31]
    },
    type: "All hotel"
}, {
    name: "House 24",
    image: "https://images.unsplash.com/photo-1533457296388-0815f9679cee?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxjb2xsZWN0aW9uLXBhZ2V8Mjh8MjMwMzE1MXx8ZW58MHx8fHw%3D&auto=format&fit=crop&w=500&q=60",
    price: 2800,
    city: "BIHAR",
    address: "204-xbc nagar,wyz-road",
    info: {
        bed: 1,
        bathrooms: 1,
        area: "76x2",
        date: [1, 31]
    },
    type: "All oyo"
}, {
    name: "House 25",
    image: "https://images.unsplash.com/photo-1506429937242-f846f7c03553?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxjb2xsZWN0aW9uLXBhZ2V8Mjd8MjMwMzE1MXx8ZW58MHx8fHw%3D&auto=format&fit=crop&w=500&q=60",
    price: 2800,
    city: "GOA",
    address: "204-ybc nagar,xyz-road",
    info: {
        bed: 1,
        bathrooms: 1,
        area: "76x2",
        date: [1, 31]
    },
    type: "All oyo"
}, {
    name: "House 26",
    image: "https://images.unsplash.com/photo-1537899680-62828e0bf8b5?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxjb2xsZWN0aW9uLXBhZ2V8MjZ8MjMwMzE1MXx8ZW58MHx8fHw%3D&auto=format&fit=crop&w=500&q=60",
    price: 2800,
    city: "SHIMLA",
    address: "204-zbc nagar,yyz-road",
    info: {
        bed: 1,
        bathrooms: 1,
        area: "76x2",
        date: [1, 31]
    },
    type: "All oyo"
}, {
    name: "House 27",
    image: "https://images.unsplash.com/photo-1532565336580-e9ccbba53cba?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxjb2xsZWN0aW9uLXBhZ2V8NDZ8MjMwMzE1MXx8ZW58MHx8fHw%3D&auto=format&fit=crop&w=500&q=60",
    price: 650,
    address: "204-mbc nagar,lyz-road",
    city: "AGRA",
    info: {
        bed: 5,
        bathrooms: 2,
        area: "33x4",
        date: [1, 31]
    },
    type: "All house"
}, {
    name: "House 28",
    image: "https://images.unsplash.com/photo-1524781315920-4275382e7f8b?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxjb2xsZWN0aW9uLXBhZ2V8NDV8MjMwMzE1MXx8ZW58MHx8fHw%3D&auto=format&fit=crop&w=500&q=60",
    price: 499,
    city: "INDORE",
    address: "204-nbc nagar,myz-road",
    info: {
        bed: 3,
        bathrooms: 1,
        area: "36x2",
        date: [1, 31]
    },
    type: "All pg"
}, {
    name: "House 29",
    image: "https://images.unsplash.com/photo-1533797076203-b28b354d8a31?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxjb2xsZWN0aW9uLXBhZ2V8MzF8MjMwMzE1MXx8ZW58MHx8fHw%3D&auto=format&fit=crop&w=500&q=60",
    price: 2850,
    city: "JAIPUR",
    address: "204-obc nagar,nyz-road",
    info: {
        bed: 2,
        bathrooms: 6,
        area: "76x2",
        date: [1, 31]
    },
    type: "All farm-house"
}, {
    name: "House 30",
    image: "https://images.unsplash.com/photo-1492963443008-9620224fd682?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxjb2xsZWN0aW9uLXBhZ2V8MzB8MjMwMzE1MXx8ZW58MHx8fHw%3D&auto=format&fit=crop&w=500&q=60",
    price: 2399,
    city: "PATNA",
    address: "204-pbc nagar,oyz-road",
    info: {
        bed: 4,
        bathrooms: 4,
        area: "100x20",
        date: [1, 31]
    },
    type: "All villa"
}, {
    name: "House 31",
    image: "https://images.unsplash.com/photo-1498903608755-e0c050a03096?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxjb2xsZWN0aW9uLXBhZ2V8MzR8MjMwMzE1MXx8ZW58MHx8fHw%3D&auto=format&fit=crop&w=500&q=60",
    price: 1800,
    city: "NAGPUR",
    address: "204-qbc nagar,pyz-road",
    info: {
        bed: 2,
        bathrooms: 1,
        area: "76x2",
        date: [1, 31]
    },
    type: "All hotel"
}, {
    name: "House 32",
    image: "https://images.unsplash.com/photo-1493183181075-439888fc4176?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxjb2xsZWN0aW9uLXBhZ2V8Mzd8MjMwMzE1MXx8ZW58MHx8fHw%3D&auto=format&fit=crop&w=500&q=60",
    price: 1200,
    city: "CHANDIGARH",
    address: "204-rbc nagar,qyz-road",
    info: {
        bed: 1,
        bathrooms: 1,
        area: "76x2",
        date: [1, 31]
    },
    type: "All oyo"
}, {
    name: "House 33",
    image: "https://images.unsplash.com/photo-1525378029868-2104f27a9847?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxjb2xsZWN0aW9uLXBhZ2V8MzZ8MjMwMzE1MXx8ZW58MHx8fHw%3D&auto=format&fit=crop&w=500&q=60",
    price: 950,
    address: "204-sbc nagar,ryz-road",
    city: "BHOPAL",
    info: {
        bed: 5,
        bathrooms: 2,
        area: "33x4",
        date: [1, 31]
    },
    type: "All house"
}, {
    name: "House 34",
    image: "https://images.unsplash.com/photo-1526934607779-546ac411ed00?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxjb2xsZWN0aW9uLXBhZ2V8MzV8MjMwMzE1MXx8ZW58MHx8fHw%3D&auto=format&fit=crop&w=500&q=60",
    price: 460,
    city: "NOIDA",
    address: "204-tbc nagar,syz-road",
    info: {
        bed: 3,
        bathrooms: 1,
        area: "36x2",
        date: [1, 31]
    },
    type: "All pg"
}, {
    name: "House 35",
    image: "https://images.unsplash.com/photo-1516562618495-ad1ff1a273f9?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxjb2xsZWN0aW9uLXBhZ2V8NDB8MjMwMzE1MXx8ZW58MHx8fHw%3D&auto=format&fit=crop&w=500&q=60",
    price: 2650,
    city: "KANPUR",
    address: "204-ubc nagar,tyz-road",
    info: {
        bed: 2,
        bathrooms: 6,
        area: "76x2",
        date: [1, 31]
    },
    type: "All farm-house"
}, {
    name: "House 36",
    image: "https://images.unsplash.com/photo-1541855870767-2e17af2996c1?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxjb2xsZWN0aW9uLXBhZ2V8Mzl8MjMwMzE1MXx8ZW58MHx8fHw%3D&auto=format&fit=crop&w=500&q=60",
    price: 2300,
    city: "GHAZIABAD",
    address: "204-vbc nagar,uyz-road",
    info: {
        bed: 4,
        bathrooms: 4,
        area: "100x20",
        date: [1, 31]
    },
    type: "All villa"
}, {
    name: "House 37",
    image: "https://images.unsplash.com/photo-1528483236516-e3838890e4b8?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxjb2xsZWN0aW9uLXBhZ2V8Mzh8MjMwMzE1MXx8ZW58MHx8fHw%3D&auto=format&fit=crop&w=500&q=60",
    price: 1800,
    city: "VARANASI",
    address: "204-wbc nagar,vyz-road",
    info: {
        bed: 2,
        bathrooms: 1,
        area: "76x2",
        date: [1, 31]
    },
    type: "All hotel"
}, {
    name: "House 38",
    image: "https://images.unsplash.com/photo-1518110812609-7db0925e795b?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxjb2xsZWN0aW9uLXBhZ2V8NDF8MjMwMzE1MXx8ZW58MHx8fHw%3D&auto=format&fit=crop&w=500&q=60",
    price: 1300,
    city: "BIHAR",
    address: "204-xbc nagar,wyz-road",
    info: {
        bed: 1,
        bathrooms: 1,
        area: "76x2",
        date: [1, 31]
    },
    type: "All oyo"
}, {
    name: "House 39",
    image: "https://images.unsplash.com/photo-1520636962706-211a957407f3?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxjb2xsZWN0aW9uLXBhZ2V8NDN8MjMwMzE1MXx8ZW58MHx8fHw%3D&auto=format&fit=crop&w=500&q=60",
    price: 550,
    city: "GOA",
    address: "204-ybc nagar,xyz-road",
    info: {
        bed: 1,
        bathrooms: 1,
        area: "76x2",
        date: [1, 31]
    },
    type: "All oyo"
}, {
    name: "House 40",
    image: "https://images.unsplash.com/photo-1521572098872-714c6669f5e4?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxjb2xsZWN0aW9uLXBhZ2V8NDR8MjMwMzE1MXx8ZW58MHx8fHw%3D&auto=format&fit=crop&w=500&q=60",
    price: 350,
    city: "SHIMLA",
    address: "204-zbc nagar,yyz-road",
    info: {
        bed: 1,
        bathrooms: 1,
        area: "76x2",
        date: [1, 31]
    },
    type: "All oyo"
}, {
    name: "House 41",
    image: "https://images.unsplash.com/photo-1445862820545-4958477d42d1?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxjb2xsZWN0aW9uLXBhZ2V8NDd8MjMwMzE1MXx8ZW58MHx8fHw%3D&auto=format&fit=crop&w=500&q=60",
    price: 2450,
    address: "204-abc nagar,xyz-road",
    city: "MUMBAI",
    info: {
        bed: 5,
        bathrooms: 2,
        area: "33x4",
        date: [1, 31]
    },
    type: "All house"
}, {
    name: "House 42",
    image: "https://images.unsplash.com/photo-1535083515570-0d05632e9e2d?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxjb2xsZWN0aW9uLXBhZ2V8NDh8MjMwMzE1MXx8ZW58MHx8fHw%3D&auto=format&fit=crop&w=500&q=60",
    price: 1600,
    city: "CHENNAI",
    address: "204-bbc nagar,ayz-road",
    info: {
        bed: 3,
        bathrooms: 1,
        area: "36x2",
        date: [1, 31]
    },
    type: "All pg"
}, {
    name: "House 43",
    image: "https://images.unsplash.com/photo-1506466010722-395aa2bef877?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxjb2xsZWN0aW9uLXBhZ2V8NTB8MjMwMzE1MXx8ZW58MHx8fHw%3D&auto=format&fit=crop&w=500&q=60",
    price: 1450,
    city: "HYDERABAD",
    address: "204-cbc nagar,byz-road",
    info: {
        bed: 2,
        bathrooms: 6,
        area: "76x2",
        date: [1, 31]
    },
    type: "All farm-house"
}, {
    name: "House 44",
    image: "https://images.unsplash.com/photo-1538251899360-c6c002eae878?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxjb2xsZWN0aW9uLXBhZ2V8NTJ8MjMwMzE1MXx8ZW58MHx8fHw%3D&auto=format&fit=crop&w=500&q=60",
    price: 750,
    city: "KOLKATA",
    address: "204-dbc nagar,cyz-road",
    info: {
        bed: 4,
        bathrooms: 4,
        area: "100x20",
        date: [1, 31]
    },
    type: "All villa"
}, {
    name: "House 45",
    image: "https://images.unsplash.com/photo-1528870188914-f2bdf215d06b?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxjb2xsZWN0aW9uLXBhZ2V8NTF8MjMwMzE1MXx8ZW58MHx8fHw%3D&auto=format&fit=crop&w=500&q=60",
    price: 400,
    city: "UDAIPUR",
    address: "204-ebc nagar,dyz-road",
    info: {
        bed: 2,
        bathrooms: 1,
        area: "76x2",
        date: [1, 31]
    },
    type: "All hotel"
}, {
    name: "House 46",
    image: "https://images.unsplash.com/photo-1491719966366-ea035406d1b7?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxjb2xsZWN0aW9uLXBhZ2V8NTN8MjMwMzE1MXx8ZW58MHx8fHw%3D&auto=format&fit=crop&w=500&q=60",
    price: 2900,
    city: "PUNE",
    address: "204-fbc nagar,eyz-road",
    info: {
        bed: 1,
        bathrooms: 1,
        area: "76x2",
        date: [1, 31]
    },
    type: "All oyo"
}, {
    name: "House 47",
    image: "https://images.unsplash.com/photo-1495151666610-af91a1885483?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxjb2xsZWN0aW9uLXBhZ2V8NTR8MjMwMzE1MXx8ZW58MHx8fHw%3D&auto=format&fit=crop&w=500&q=60",
    price: 450,
    address: "204-gbc nagar,fyz-road",
    city: "BANGLORE",
    info: {
        bed: 5,
        bathrooms: 2,
        area: "33x4",
        date: [1, 31]
    },
    type: "All house"
}, {
    name: "House 48",
    image: "https://images.unsplash.com/photo-1496898869866-f951ec7330a2?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxjb2xsZWN0aW9uLXBhZ2V8NTV8MjMwMzE1MXx8ZW58MHx8fHw%3D&auto=format&fit=crop&w=500&q=60",
    price: 2100,
    city: "AHEMDABAD",
    address: "204-hbc nagar,gyz-road",
    info: {
        bed: 3,
        bathrooms: 1,
        area: "36x2",
        date: [1, 31]
    },
    type: "All pg"
}, {
    name: "House 49",
    image: "https://images.unsplash.com/photo-1539539448744-05b9616b7ec9?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxjb2xsZWN0aW9uLXBhZ2V8NTZ8MjMwMzE1MXx8ZW58MHx8fHw%3D&auto=format&fit=crop&w=500&q=60",
    price: 1700,
    city: "SURAT",
    address: "204-ibc nagar,hyz-road",
    info: {
        bed: 2,
        bathrooms: 6,
        area: "76x2",
        date: [1, 31]
    },
    type: "All farm-house"
}, {
    name: "House 50",
    image: "https://images.unsplash.com/photo-1541779133717-50ec837990eb?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxjb2xsZWN0aW9uLXBhZ2V8NTh8MjMwMzE1MXx8ZW58MHx8fHw%3D&auto=format&fit=crop&w=500&q=60",
    price: 1200,
    city: "VISHAKAPATNAM",
    address: "204-jbc nagar,iyz-road",
    info: {
        bed: 4,
        bathrooms: 4,
        area: "100x20",
        date: [1, 31]
    },
    type: "All villa"
}, {
    name: "House 51",
    image: "https://images.unsplash.com/photo-1440008357880-02f945e874a9?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxjb2xsZWN0aW9uLXBhZ2V8NjB8MjMwMzE1MXx8ZW58MHx8fHw%3D&auto=format&fit=crop&w=500&q=60",
    price: 800,
    city: "New Delhi",
    address: "204-kbc nagar,jyz-road",
    info: {
        bed: 2,
        bathrooms: 1,
        area: "76x2",
        date: [1, 31]
    },
    type: "All hotel"
}, {
    name: "House 52",
    image: "https://images.unsplash.com/photo-1539777964120-b2fec736fcaa?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxjb2xsZWN0aW9uLXBhZ2V8NTl8MjMwMzE1MXx8ZW58MHx8fHw%3D&auto=format&fit=crop&w=500&q=60",
    price: 400,
    city: "LUCKNOW",
    address: "204-lbc nagar,kyz-road",
    info: {
        bed: 1,
        bathrooms: 1,
        area: "76x2",
        date: [1, 31]
    },
    type: "All oyo"
}]
